module.exports = __webpack_public_path__ + "static/RST-PIO-CAN-Monitoring-System2-92c14470ed7028353522ff0895ce4ba3.png";